import { ReactComponent as AmwayFilledLogo } from "./svg/amwayFilledLogoIcon.svg";
import "./AmwayFilledLogoIcon.scss";

export const AmwayFilledLogoIcon = () => {
  return <AmwayFilledLogo className="amway-filled-logo-icon" aria-hidden="true" focusable="false" />;
};
